/* ShimChingMD · Recovery Cloud story (Oct 2026) */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function openCart() {
    ['cart:refresh', 'cart:updated'].forEach(function (ev) { document.dispatchEvent(new CustomEvent(ev, { bubbles: true })); });
    var d = document.querySelector('cart-drawer, #cart-drawer, .cart-drawer, [data-cart-drawer]');
    if (d && typeof d.refreshCartDrawer === 'function') {
      try { Promise.resolve(d.refreshCartDrawer()).then(function () { if (typeof d.open === 'function') d.open(); }).catch(function () { if (typeof d.open === 'function') d.open(); }); return; } catch (e) {}
    }
    if (d && typeof d.open === 'function') { try { d.open(); return; } catch (e) {} }
    var tg = document.querySelector('[data-cart-toggle], [data-cart-drawer-toggle], [aria-controls="cart-drawer"], #cart-icon-bubble, .header__icon--cart');
    if (tg) { tg.click(); return; }
    location.href = '/cart';
  }

  function init(root) {
    if (root.__rcx) return; root.__rcx = true;
    root.classList.add('js');

    /* reveals */
    var rv = root.querySelectorAll('.rcx-rv, [data-rcx-clip]');
    if (reduce || !('IntersectionObserver' in window)) { rv.forEach(function (n) { n.classList.add('in'); }); }
    else {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
      rv.forEach(function (n) { io.observe(n); });
    }

    /* scroll-linked: pinned cloud scene + parallax bands */
    var pins = Array.prototype.slice.call(root.querySelectorAll('[data-rcx-pin]'));
    var pars = Array.prototype.slice.call(root.querySelectorAll('[data-rcx-par]'));
    if (!reduce && (pins.length || pars.length)) {
      var ticking = false;
      var frame = function () {
        ticking = false;
        var vh = window.innerHeight || 800;
        pins.forEach(function (sec) {
          var r = sec.getBoundingClientRect();
          var span = Math.max(1, r.height - vh);
          var p = Math.min(1, Math.max(0, -r.top / span));
          sec.style.setProperty('--p', p.toFixed(4));
        });
        pars.forEach(function (sec) {
          var r = sec.getBoundingClientRect();
          if (r.bottom < -100 || r.top > vh + 100) return;
          var c = (r.top + r.height / 2 - vh / 2) / (vh + r.height);
          var img = sec.querySelector('.rcx-par');
          if (img) img.style.transform = 'translate3d(0,' + (c * -12).toFixed(2) + '%,0)';
        });
      };
      var onScroll = function () { if (!ticking) { ticking = true; window.requestAnimationFrame(frame); } };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      frame();
    } else {
      pins.forEach(function (sec) { sec.style.setProperty('--p', '1'); });
    }

    /* quick add (ritual steps) */
    var err = root.querySelector('[data-rcx-err]');
    root.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('[data-rcx-add]');
      if (b && root.contains(b)) {
        ev.preventDefault();
        var id = parseInt(b.getAttribute('data-rcx-add'), 10); if (!id) return;
        var t = b.querySelector('.rcx-add__t'); var was = t ? t.textContent : '';
        b.setAttribute('aria-busy', 'true'); if (err) err.hidden = true;
        fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart.'); return j; }); })
          .then(function () {
            b.removeAttribute('aria-busy'); b.classList.add('is-added'); if (t) t.textContent = 'Added';
            setTimeout(function () { b.classList.remove('is-added'); if (t) t.textContent = was; }, 2600);
            openCart();
          })
          .catch(function (e) { b.removeAttribute('aria-busy'); if (err) { err.textContent = e.message; err.hidden = false; } });
        return;
      }
      /* night band: use the hero's real product form (keeps variants, plans and apps in one place) */
      var buy = ev.target.closest && ev.target.closest('[data-rcx-buy]');
      if (buy && root.contains(buy)) {
        ev.preventDefault();
        var atc = document.querySelector('[data-sci-form] [data-atc], #sci-form [data-atc]');
        if (atc && !atc.disabled) { atc.click(); return; }
        var form = document.querySelector('[data-sci-form], #sci-form');
        if (form) form.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      }
    });
  }

  function boot() { document.querySelectorAll('[data-rcx]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
